
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import FormDialog from '@/components/dialogs/FormDialog.vue';
import NewFormDialog from '@/components/dialogs/NewFormDialog.vue';
import UyapIlamBilgileriForm from '@/components/eicrapro/UyapIlamBilgileriForm.vue';
import TakipHazirlaVekaletEkleDialog from '@/components/eicrapro/TakipHazirlaVekaletEkleDialog.vue';
import DayanakList from '@/components/eicrapro/DayanakList.vue';
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {TakipAcStatusEnum} from "@/plugins/uyap-plugin/takip_ac/parser/TakipAcStatusEnum";
import UyapTakipAc from "@/plugins/uyap-plugin/takip_ac/UyapTakipAc";
import MtsTakipAc from "@/plugins/uyap-plugin/takip_ac/MtsTakipAc";
import {AxiosResponse} from "axios";

@Component({
  components: {
    DeleteDialog,
    FormDialog,
    NewFormDialog,
    UyapIlamBilgileriForm,
    TakipHazirlaVekaletEkleDialog,
    DayanakList,
  },
})
export default class ActionsColumn extends Vue {
  @Prop({required: true}) readonly item!: UyapTakipAc | MtsTakipAc;
  @Prop({default: false}) readonly disabled!: boolean;
  @Prop({default: false}) readonly isMts!: boolean;

  takipAcStatusEnum = TakipAcStatusEnum;
  hashDeleted: boolean = false;

  get isSubmitting(): boolean {
    const module = this.isMts ? 'mtsTakipHazirla' : 'takipHazirla';
    return this.$store.getters[`${module}/isSubmitting`] || false;
  }

  @Watch('isSubmitting')
  onIsSubmittingChange(val: boolean): void {
    if (val) this.hashDeleted = false;
  }

  get isIlamli(): boolean {
    if (this.isMts)
      return false;
    return (this.item as UyapTakipAc).parsedFile?.isIlamli();
  }

  get isIlamBilgisiTam(): boolean {
    if (!this.item.parsedFile?.isIlamli()) return false;
    try {
      const ilam = this.item.parsedFile.getIlamBilgileri();
      if (!ilam) return false;
      return !!(ilam.birimId && ilam.dosyaYil && ilam.dosyaSira);
    } catch (e) {
      return false;
    }
  }

  get getIlamIconColor(): string {
    if (this.isIlamBilgisiTam) {
      return '#4CAF50';
    }
    return this.item.parsedFile.ilamSorgusu?.status ? '#64748b' : '#c62828';
  }

  get getIlamTooltip(): string {
    if (this.isIlamBilgisiTam) {
      return 'İlam bilgileri bulunmaktadır (Görüntüleme)';
    }
    return 'UYAP İlam Bilgileri';
  }

  get hasVekalet(): boolean {
    return !!this.item.parsedFile?.vekalet || !!this.item.parsedFile?.vekaletObject?.id;
  }

  handlePerRowVekaletSuccess(vekalet: any, onClose: () => void) {
    const isExistingVekalet = vekalet.id && !vekalet.data;
    if (isExistingVekalet) {
      this.item.parsedFile.vekaletObject = vekalet;
    } else {
      this.item.parsedFile.vekalet = vekalet;
    }
    onClose();
  }

  async deleteHash(hash: string): Promise<void> {
    const res: AxiosResponse<{ success: boolean; message?: string }> = await this.$http.delete('/api/v1/uyap-takip-hash?hash=' + hash);
    if (res.data.success) {
      this.$toast.success(res.data.message || 'Hash silme başarılı.');
    } else {
      this.$toast.warning(res.data.message || 'Hash bulunamadı.');
    }

  }
}
